import { useState } from "react";
import { useListContext } from "ra-core";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";

export function MobileListSearch({ label }: { label: string }) {
  const { filterValues, setFilters } = useListContext();
  const [search, setSearch] = useState(filterValues.q ?? "");
  return (
    <div data-mobile-search className="relative mb-4 min-w-0">
      <Search className="pointer-events-none absolute left-3 top-3.5 size-4 text-muted-foreground" />
      <Input
        aria-label={label}
        placeholder={label}
        className="h-11 rounded-xl bg-card pl-9"
        value={search}
        onChange={(event) => {
          setSearch(event.target.value);
          setFilters(
            { ...filterValues, q: event.target.value },
            undefined,
            true,
          );
        }}
      />
    </div>
  );
}
